module.exports = __webpack_public_path__ + "static/media/BellNotificationIcon.c5e24676.svg";